// SuperAdminRoute.tsx - Protege rutas exclusivas del super-admin
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import SuperAdminLayout from '../../components/SuperAdminLayout';

interface SuperAdminRouteProps {
    children: ReactNode;
}

const SuperAdminRoute = ({ children }: SuperAdminRouteProps) => {
    const { user, userData, loading } = useAuth();
    const location = useLocation();

    // Mostrar loading mientras se verifica la autenticación
    if (loading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                background: '#f3f4f6'
            }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    border: '4px solid #e5e7eb',
                    borderTopColor: '#3b82f6',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }} />
                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
        );
    }

    // Si no está autenticado → login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Si está autenticado pero no es super_admin → dashboard normal
    if (userData && userData.role !== 'super_admin') {
        return <Navigate to="/dashboard" replace />;
    }

    // Super admin autenticado → mostrar con SuperAdminLayout (sin título, cada página pone el suyo)
    return <SuperAdminLayout>{children}</SuperAdminLayout>;
};

export default SuperAdminRoute;
